import React from 'react';
import { Layout, Menu, Button, Space, Typography } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RocketOutlined, BugOutlined } from '@ant-design/icons';
import LanguageSwitcher from './LanguageSwitcher';
import './LandingLayout.css';
import './Footer.css';
import './CenterLayout.css';

const { Header, Content, Footer } = Layout;
const { Text, Title } = Typography;

interface LandingLayoutProps {
  children: React.ReactNode;
}

const LandingLayout: React.FC<LandingLayoutProps> = ({ children }) => {
  const { t } = useTranslation('landing');
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      key: '/',
      label: t('landing.menu.home'),
    },
    {
      key: '/about',
      label: t('landing.menu.about'),
    },
    {
      key: '/pricing',
      label: t('landing.menu.pricing'),
    },
    {
      key: '/contact',
      label: t('landing.menu.contact'),
    },
  ];

  return (
    <Layout className="landing-layout">
      <Header className="landing-header">
        <div className="header-container">
          <Link to="/" className="logo">
            <RocketOutlined className="logo-icon" />
            <span className="logo-text">QATE</span>
          </Link>
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            className="landing-menu"
            onClick={({ key }) => navigate(key)}
          />
          <Space size="middle">
            <LanguageSwitcher />
            <Button type="link" onClick={() => navigate('/login')}>
              {t('landing.menu.login')}
            </Button>
            <Button type="primary" onClick={() => navigate('/register')}>
              {t('landing.menu.register')}
            </Button>
          </Space>
        </div>
      </Header>
      <Content className="landing-content">
        {children}
      </Content>
      <Footer className="landing-footer">
        <div className="footer-container">
          <div className="footer-main">
            <div className="footer-brand">
              <h2 className="footer-title">QATE</h2>
              <p className="footer-description">
                {t('landing.footer.description')}
              </p>
            </div>
            <div className="footer-section">
              <h3 className="footer-section-title">{t('landing.footer.product.title')}</h3>
              <div className="footer-links">
                <a href="/" className="footer-link">{t('landing.footer.product.home')}</a>
                <a href="/features" className="footer-link">{t('landing.footer.product.features')}</a>
                <a href="/pricing" className="footer-link">{t('landing.footer.product.pricing')}</a>
                <a href="/about" className="footer-link">{t('landing.footer.product.about')}</a>
              </div>
            </div>
            <div className="footer-section">
              <h3 className="footer-section-title">{t('landing.footer.support.title')}</h3>
              <div className="footer-links">
                <a href="/privacy" className="footer-link">{t('landing.footer.support.privacy')}</a>
                <a href="/terms" className="footer-link">{t('landing.footer.support.terms')}</a>
                <a href="/contact" className="footer-link">{t('landing.footer.support.contact')}</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p className="footer-copyright">
              {t('landing.footer.copyright')}
            </p>
          </div>
        </div>
      </Footer>
    </Layout>
  );
};

export default LandingLayout; 